import { getEntityTypeFromPath } from 'app/infrastructure/store/entity';
import { StoreData } from 'app/types-shared';
import {
  getCaseData,
  getEntityContext
} from 'app/infrastructure/ui/renderer/resolvers';
import { CaseState } from 'app/area/case/types-store';
import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';
import { getStorePath } from 'app/infrastructure/store/path';
import { getChildEntities } from 'app/infrastructure/store/query';

export interface ChildValueItemsMapping {
  /**
   * The name to use for the aggregation result
   */
  propName: string;
  /**
   * This is the data path with optional ids to match for each entity.
   * The ancestors with no specified id will be matched by using the component context.
   */
  entityPath: { entityType: string; id?: number }[];
}

/**
 * Returns an object map with values, for each defined property to aggreate, of a child entity type
 */

export const childEntityValuesAsProperty = (
  propertyName: string,
  propMappings: ChildValueItemsMapping[]
) => (caseState: CaseState, uiEngineProps: ConnectedComponentProps) => {
  const valueItems = {};

  propMappings.forEach(prop => {
    const entityTypePath = prop.entityPath.map(d => d.entityType);

    const caseData: StoreData = getCaseData(caseState, uiEngineProps);
    const entityContext = getEntityContext(caseState, uiEngineProps);
    const storePath = getStorePath(entityTypePath, entityContext.path, true);
    const entityType = getEntityTypeFromPath(entityTypePath);
    const allRows = getChildEntities(caseData, storePath, entityType);

    valueItems[prop.propName] =
      allRows &&
      allRows
        .map(p =>
          Array.isArray(p[prop.propName]) ? p[prop.propName][0] : undefined
        )
        .filter(x => x);
  });

  return { [propertyName]: valueItems };
};

export interface ChildValueItemsShape {
  childValueItems: any;
}
